/**
 * HUD panels: the currencies row (top left), round menu icons (top right), keystone tracker +
 * collapsible meters (right), loot feed (left centre) and keybind hints (bottom right).
 * Registered through hud/widgets.ts (`...PANEL_WIDGETS`).
 */
import type { HudWidgetDef } from '../widgets';
import { CurrenciesRow } from './currencies';
import { KeyHints, keyHintsRef } from './keyHints';
import { LootFeed } from './lootFeed';
import { MenuBar } from './menuBar';
import { MetersWidget, metersRef } from './meters';
import { KeystoneTracker } from './tracker';
import './panels.css';

export const PANEL_WIDGETS: HudWidgetDef[] = [
  { id: 'currencies', region: 'topLeft', create: (host) => new CurrenciesRow(host) },
  { id: 'menu', region: 'topRight', create: (host, ctx) => new MenuBar(host, ctx) },
  { id: 'tracker', region: 'right', replaces: ['keystone'], create: (host) => new KeystoneTracker(host) },
  {
    id: 'meters',
    region: 'right',
    replaces: ['meters'],
    create: (host) => {
      const w = (metersRef.current = new MetersWidget(host));
      return {
        update: (h, now) => w.update(h, now),
        dispose: () => {
          if (metersRef.current === w) metersRef.current = null;
        },
      };
    },
  },
  {
    id: 'lootFeed',
    region: 'leftCenter',
    create: (host) => new LootFeed(host),
  },
  {
    id: 'keyHints',
    region: 'bottomRight',
    create: (host) => {
      const w = (keyHintsRef.current = new KeyHints(host));
      return {
        update: (h) => w.update(h),
        dispose: () => {
          if (keyHintsRef.current === w) keyHintsRef.current = null;
        },
      };
    },
  },
];

export { menuHotkeys, routeMenuKey, MENU_KEYS } from './hotkeys';
export { fillTrackerView, emptyTrackerView, chestFor } from './trackerModel';
